import { MijnRoute } from '../../mijn-navigatie.model';

export const MESSAGE_OVERVIEW: MijnRoute = {
    path: 'berichten',
    navigationEvent: 'toBerichten',
    regex: /^\/berichten$/,
    webcomponent: 'mijn-berichten-overzicht-webcomponent'
};
